<template>
  <div id="app">
    <div class="header">
      <img @click="$router.push('/index')" src="./assets/images/logo@2x.png">
      <el-tabs class="header-tabs" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('nav.home')" name="/index"></el-tab-pane>
        <el-tab-pane :label="$t('nav.marketArea')" name="/marketArea"></el-tab-pane>
        <el-tab-pane :label="$t('nav.productCenter')" name="/productCenter"></el-tab-pane>
        <el-tab-pane :label="$t('nav.serviceSupport')" name="/serviceSupport"></el-tab-pane>
        <!-- <el-tab-pane :label="$t('nav.news')" name="/news"></el-tab-pane> -->
        <el-tab-pane :label="$t('nav.contactUs')" name="/contactUs"></el-tab-pane>
      </el-tabs>
      
      <!-- 语言切换下拉菜单 -->
      <el-dropdown class="language-dropdown" @command="handleLanguageChange" placement="bottom">
        <span class="language-trigger">
          Language <i class="el-icon-caret-top"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="ssss">
          <el-dropdown-item command="de" :class="{ 'active': currentLanguage === 'de' }"><img src="./assets/images2/de.png">{{ $t('lang.de') }}</el-dropdown-item>
          <el-dropdown-item command="en" :class="{ 'active': currentLanguage === 'en' }"><img src="./assets/images2/en.png">{{ $t('lang.en') }}</el-dropdown-item>
          <el-dropdown-item command="zh" :class="{ 'active': currentLanguage === 'zh' }"><img src="./assets/images2/cn.png">{{ $t('lang.zh') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

      <!-- 路由出口 -->
      <router-view />
    <pageFooter></pageFooter>
  </div>
</template>

<script>
import pageFooter from '@/components/pageFooter.vue'
export default {
  name: 'App',
  data () {
    return {
      activeName: '/index',
      currentLanguage: 'de' // 默认中文
    }
  },
  watch: {
    '$route' (to) {
      // 路由变化时同步activeName
      this.activeName = this.getParentRoutePath(to)
      
      // 路由变化时滚动到页面顶部
      this.scrollToTop()
    }
  },
  mounted() {
    // 初始化：根据当前路由设置高亮tab
    this.activeName = this.getParentRoutePath(this.$route)
    // 同步语言状态
    this.currentLanguage = this.$i18n.locale
  },
  methods: {
    handleClick (tab) {
      console.log(tab)
      this.$router.push(tab.name)
    },
    
    // 处理语言切换
    handleLanguageChange(lang) {
      this.currentLanguage = lang
      this.$i18n.locale = lang
      localStorage.setItem('locale', lang)
    },
    // 获取路由对应的父级路径（即一级路径）
    getParentRoutePath (route) {
      // 如果当前路径就是一级路径（如 /index, /marketArea），直接返回
      const path = route.path
      // 判断是否为一级路径：路径中只包含一个斜杠（除了开头的）
      const segments = path.split('/').filter(seg => seg !== '')
      if (segments.length <= 1) {
        return path === '/' ? '/' : path
      }
      // 否则取第一个段，构造一级路径
      return '/' + segments[0]
    },
    
    // 滚动到页面顶部
    scrollToTop() {
      // 使用多种方法确保兼容性
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      
      // 如果使用了路由视图容器，也可以尝试滚动容器
      const routerView = document.querySelector('.router-view-container')
      if (routerView) {
        routerView.scrollTop = 0
      }
    }
  },
  components: {
    pageFooter
  }
}
</script>

<style scoped>
#app {
  margin: 0;
  padding: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.header {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  position: relative;
}
.header img {
  width: 120px;
  height: 32px;
  margin-right: 170px;
  cursor: pointer;
}
#app /deep/ .header-tabs .el-tabs__header {
  margin-bottom: 0;
}
#app /deep/ .header-tabs .el-tabs__item{
  height: 80px;
  line-height: 80px;
}
#app /deep/ .header-tabs .el-tabs__nav-wrap::after {
  display: none;
}

/* 语言切换下拉菜单样式 */
.language-dropdown {
  position: absolute;
  right:0;
  top:0;
  cursor: pointer;
}

.language-trigger {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #303133;
  height: 80px;
  line-height: 80px;
  
}


.language-trigger i {
  margin-left: 5px;
  font-size: 12px;
}

.language-trigger:hover {
  color: #409EFF;
}

.ssss li{
  height:40px;
  display: flex;
  align-items: center;
}
.ssss li img{
margin-right:5px;
} 
</style>

<!-- 全局样式，用于下拉菜单选中状态 -->
<style>
.el-dropdown-menu .el-dropdown-item.active {
  color: #409EFF;
}
</style>
